import React from 'react';
import { Link, IndexLink } from 'react-router-dom';

import * as constant from "../../../constants/constant";
import * as ImageUrl from "../../../constants/constant";

export default function DisputeHeader(props) {
    let inputElement = React.createRef();
    var user = localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')) : {};

    if (user && user.gender == undefined) {
        user = { ...user, gender: 'Male' }
        // localStorage.setItem('user', JSON.stringify(user));
        // user = JSON.parse(localStorage.getItem("user"));
    }
    // var gender = localStorage.getItem('user')
    var defaultImagePath = (user && user.gender) == 'Male' ?
        constant.PRODUCTION_IMAGE_URL + "uploads/common/patient_m.png" : constant.PRODUCTION_IMAGE_URL + "uploads/common/patient_f.png";
    var imagePath = ''
    if (user && user.image == "noUserImage.jpg") {
        imagePath = user && user.gender == 'Male' ?
            constant.PRODUCTION_IMAGE_URL + "uploads/common/patient_m.png" : constant.PRODUCTION_IMAGE_URL + "uploads/common/patient_f.png";
    } else {
        imagePath =
            ImageUrl.PRODUCTION_IMAGE_URL +
            "uploads/" +
            localStorage.getItem("userId") +
            "/" +
            (user && user.image);
    }
    return (
        <div className="header">
            <div className="left d-flex align-content-center"><Link to="/"><img src={require('../../../images/images/logo.svg')} alt="" /></Link> <span>Assist</span> </div>
            <div className="right">

                <span><i className="fa fa-map-marker" aria-hidden="true"></i>{"  "+localStorage.getItem('locality')}</span>
                {/* <ul className="clearfix"> */}

                {/* <li><span className="location">Toronto <i className="fa fa-map-marker" aria-hidden="true"></i></span></li> */}
                <nav className="navbar navbar-static-top" role="navigation">

                    <div className="navbar-custom-menu">
                        <ul className="nav navbar-nav">
                            <li ref={node => { inputElement = node; }} onClick={props.handleClick} className={props.logoutButton == true ? "dropdown user user-menu show" : "dropdown user user-menu"}>
                                <Link
                                    to="#"
                                    className="dropdown-toggle"
                                    data-toggle="dropdown"
                                >
                                    <img
                                        src={imagePath}
                                        className="user-image"
                                        alt="User Image"
                                        onError={e => {
                                            e.target.src = defaultImagePath;
                                        }}
                                    />
                                    <span className="hidden-xs name-capitalize">
                                        {user && user.userName ? user && user.userName : "Medfix User"}
                                    </span>
                                </Link>
                                <ul className={props.logoutButton === true ? "dropdown-menu popupdropdown show" : "dropdown-menu popupdropdown"}>

                                    <li className="user-setting">	<Link to={{ pathname: "/dashboard/my-setting", state: 1 }}>

                                        <img
                                            src={require('../../../images/Slicing/Settings-profile.png')}
                                            className="user-image"
                                            alt="User Image"
                                            onError={e => {
                                                e.target.src = defaultImagePath;
                                            }}
                                        />
                                        <span>Settings</span>
                                    </Link></li>
                                    <li
                                        className="user-footer passwordLink"
                                    // style={{ textAlign: "center" }}
                                    >

                                        <Link to="#"
                                            className="uploadLink"
                                            onClick={(e) => props._logout(e)}
                                        >
                                            <img
                                                src={require('../../../images/Slicing/logout-profile.png')}
                                                className="user-image"
                                                alt="User Image"
                                                onError={e => {
                                                    e.target.src = defaultImagePath;
                                                }}
                                            />
                                            <span>	Sign out</span>
                                        </Link>
                                    </li>
                                </ul>
                            </li>
                        </ul>
                    </div>
                </nav>
                {/* <li>
                                 <div className="user-img"><img src="https://picsum.photos/id/237/100/100"></img></div>
                                 <span className="user-name">syed</span>
                              </li> */}
                {/* </ul> */}
            </div>

        </div>
    )
}